import { HelmetProvider } from "react-helmet-async";
import { initDB } from "react-indexed-db";
import { config } from "./database";
import AppRouter from "routes/AppRouter";
import { StoreContextWrapper } from "store/StoreContextWrapper";

import "antd/dist/antd.css";

initDB(config);

const App = () => (
  <div className="App">
    <StoreContextWrapper>
      <HelmetProvider>
        <AppRouter />
      </HelmetProvider>
    </StoreContextWrapper>
  </div>
);

export default App;
